import React, { FC } from 'react';
import classnames from 'classnames';
import Svg from 'svg-inline-react';
import { Avatar } from '@src/components/Avatar';
import { ActionMenuPopover } from '@src/components/Popover';
import { LinkedIn } from '@src/components/LinkedIn';
import { trackEvent } from '@src/metrics';
import { getNameInitials } from '@src/util/getNameInitials';
import { MetricAction, MetricContext, MetricEventSource } from '@src/metrics/metrics.enum';
import { UserProfileLinkTypeEnum } from '@src/graphql/generated';
import CloseSvg from '@src/svgs/close.svg';
import { CandidateProfileHeaderWithUserProps } from './props';

export const CandidateProfileHeaderWithUser: FC<CandidateProfileHeaderWithUserProps> = ({
  className,
  actions,
  metricsContext,
  onClose,
  user,
}) => {
  const linkedIn = user.profile.links.find(link => link.type === UserProfileLinkTypeEnum.LINKEDIN);

  const linkedInUrl = linkedIn?.value;
  const name = user.name;
  const position = user.position;
  const avatarColor = user.avatarColor;
  const locationShortName = user.profile.location.shortName;

  return (
    <div className={classnames('candidate-profile-header', className)}>
      <div className="candidate-profile-header__actions">
        {!!actions.length && <ActionMenuPopover actions={actions} onAction={item => actions[item.index].action()} />}

        {onClose && <Svg className="candidate-profile-header__close-btn" onClick={onClose} src={CloseSvg} />}
      </div>

      <div className="candidate-profile-header__user-wrapper">
        <Avatar avatarColor={avatarColor} initials={getNameInitials(name)} size="xx-large" />

        <div className="candidate-profile-header__user">
          <div className="candidate-profile-header__container">
            <div className="candidate-profile-header__name" title={name || undefined}>
              {name}
            </div>

            <LinkedIn
              linkedInUrl={linkedInUrl}
              onClick={() =>
                trackEvent({
                  context: MetricContext.CANDIDATE_MANAGEMENT,
                  interaction: MetricAction.OPEN_LINKEDIN,
                  payload: {
                    'Event Source': MetricEventSource.CANDIDATE_PROFILE_LINKEDIN_ICON,
                    'Previous Context': metricsContext,
                  },
                })
              }
              wrapperClassName="candidate-profile-header__linkedin"
            />
          </div>

          <div className="candidate-profile-header__sub-title">
            <span className="candidate-profile-header__position" title={position || undefined}>
              {position}
            </span>

            {locationShortName && position && <span className="candidate-profile-header__dot" />}
            <span className="candidate-profile-header__location" title={locationShortName}>
              {locationShortName}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
